import { useDispatch } from 'react-redux';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { useCallback, useEffect, useState } from 'react';
import {
    clearTemporaryLabelColorStyles,
    setTemporaryLabelColorStyles,
} from '../../colorTools/setTemporaryLabelColorStyles';
import { getColorDefaultHexValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import { updateLabel } from '../../../../../../../common/labels/labelActions';

type ReturnType = {
    handleTempColorChange: (color: string | null) => void;
    handleColorChange: (color: string | null) => void;
    tempColor: string | null;
    setTempColor: (color: string | null) => void;
    clearPreview: () => void;
};

export const useLabelColorHandler = (label: Label | undefined): ReturnType => {
    const dispatch = useDispatch();
    const [tempColor, setTempColor] = useState<string | null>(null);

    useEffect(() => {
        setTempColor(null);

        return () => {
            if (!label?._id) return;

            clearTemporaryLabelColorStyles(label._id);
        };
    }, [label?._id]);

    const handleTempColorChange = (color: string | null) => {
        if (!label || !color) return;

        setTempColor(color);
        setTemporaryLabelColorStyles(label._id, color);
    };

    const handleColorChange = (color: string | null) => {
        if (!label) return;

        const colorToSave = color ? getColorDefaultHexValue(color) : undefined;
        dispatch(updateLabel(label._id, { color: colorToSave }));
        clearTemporaryLabelColorStyles(label._id);
        setTempColor(null);
    };

    const clearPreview = useCallback(() => {
        if (!label?._id) return;

        clearTemporaryLabelColorStyles(label._id);
        setTempColor(null);
    }, [label]);

    return {
        handleTempColorChange,
        handleColorChange,
        tempColor,
        setTempColor,
        clearPreview,
    };
};
